var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-div',{ref:"outer",staticClass:"ClampedTextBox",attrs:{"overflow-hidden":"","relative":""}},[_c(_vm.htmlElement,{tag:"component"},[_vm._t("default"),_vm._v(" "),(_vm.isOverflowing)?_c('v-div',{staticClass:"more-text",attrs:{"background-subdued":""}},[_vm._v("...")]):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }